import './bufferband.scss';
import 'slick-carousel';
import 'magnific-popup';

export default async () => {
	$( '.js-bufferband-slider' ).slick( {
		rows: 0,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		asNavFor: '.js-bufferband-nav',
	} );
	$( '.js-bufferband-nav' ).slick( {
		rows: 0,
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="far fa-chevron-left"></i></button>',
		nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="far fa-chevron-right"></i></button>',
		asNavFor: '.js-bufferband-slider',
		variableWidth: true,
		focusOnSelect: true,
	} );

	$( '.js-popup-video' ).magnificPopup( {
		disableOn: 700,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,
		fixedContentPos: false,
	} );
};
